// Configuração do Mercado Pago
export const MERCADO_PAGO_CONFIG = {
  publicKey: 'APP_USR-691f360f-e51e-4051-b6da-22b08d838201',
  sandbox: process.env.NODE_ENV !== 'production',
  currency: 'BRL',
  subscriptionPrice: 69.00,
  subscriptionTitle: 'Trajetus - Plano Mensal',
  subscriptionDescription: 'Sistema completo de gestão para psicólogos'
};

// URLs de retorno
export const CHECKOUT_URLS = {
  success: `${window.location.origin}/pagamento/sucesso`,
  failure: `${window.location.origin}/pagamento/falha`,
  pending: `${window.location.origin}/pagamento/pendente`
};